import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { FloatingCta } from './components/FloatingCta';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero } from './components/sections/Hero';
import { Transformation } from './components/sections/Transformation';
import { BeforeAfter } from './components/sections/BeforeAfter';
import { PainPoints } from './components/sections/PainPoints';
import { Volumes } from './components/sections/Volumes';
import { Toolkit } from './components/sections/Toolkit';
import { Bonuses } from './components/sections/Bonuses';
import { Offer } from './components/sections/Offer';
import { Guarantee } from './components/sections/Guarantee';
import { Testimonials } from './components/sections/Testimonials';
import { About } from './components/sections/About';
import { Faq } from './components/sections/Faq';
import { FinalCta } from './components/sections/FinalCta';
import { Footer } from './components/sections/Footer';
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-canvas font-sans text-ink" data-id="element-0" data-mp="3ij63w8owfj7c">
      <MetaPixel data-id="element-1" data-mp="3mkhn9wh6j873" />
      <Hero data-id="element-2" data-mp="3mjzuj9tq7c3x" />
      <main data-id="element-3" data-mp="3mjpyp5m02aqb">
        <Transformation data-id="element-4" data-mp="3mj6jvxrnc2gi" />
        <BeforeAfter data-id="element-5" data-mp="3rbr9so7flver" />
        <PainPoints data-id="element-6" data-mp="3rdaselgk8ijp" />
        <Volumes data-id="element-7" data-mp="3rcsulke91w9o" />
        <Toolkit data-id="element-8" data-mp="3recbnd7qcbci" />
        <Bonuses data-id="element-9" data-mp="5yh2n2cyzbp" />
        <Offer data-id="element-10" data-mp="6htxpd5ixiv" />
        <Guarantee data-id="element-11" data-mp="4wwnrzgd0hb" />
        <Testimonials data-id="element-12" data-mp="5gbv0xpxarn" />
        <About data-id="element-13" data-mp="7svdij4jt6t" />
        <Faq data-id="element-14" data-mp="2zld0z6e9z99y" />
        <FinalCta data-id="element-15" data-mp="2zlld2w2kqak3" />
      </main>
      <Footer data-id="element-16" data-mp="2zmo4r67q0h12" />
      <FloatingCta data-id="element-17" data-mp="2zmwh8wzxlkbq" />
      <PurchasePopup data-id="element-18" data-mp="2znfy0adui2o6" />
    </div>;
}